import styled from 'styled-components';
import ProfileSvg from '../../assets/settings/profile.svg';

const ProfileIcon = styled(ProfileSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`

width: ${props => props.width || '2.4rem'};
height: ${props => props.height || '2.4rem'};
margin: ${props => props.margin};
fill: ${props => props.fill};
`;

export default ProfileIcon;
